export default function extractError() {
  const errors = this.errors ? this.errors : [];

  if (errors.length === 0) {
    return undefined;
  }

  const item = this.entry && this.entry.item ? this.entry.item : this.item;

  const id = item.id || item.gid || item.funderId;

  const error = errors.find(
    (error) => error.fieldName === this.fieldName && error.id === id
  );

  return error ? error.errorMessage : undefined;
}
